import React, { useState, useEffect } from 'react'
import democta1 from "../../assets/imgs/demo-img-1.webp";
import democta2 from "../../assets/imgs/demo-img-2.webp";
import benifits1 from "../../assets/imgs/constituent-relationship-management.webp"
import benifits2 from "../../assets/imgs/donor-Cultivation.webp"
import benifits3 from "../../assets/imgs/grant-Management.webp"
import benifits4 from "../../assets/imgs/volunteer-Management.webp"
import benifits5 from "../../assets/imgs/fundraising-CRM.webp"
import benifits6 from "../../assets/imgs/report.webp"
import Fcontact from '../Shared/Fcontact';
import { Modal } from 'react-bootstrap';

const Benifits = () => {
    const [show, setShow] = useState(false);
    const [policy, setPolicy] = useState(false);
  
    const handleClose = () => {
      setPolicy(false);
      setShow(false);
    };
    const handleShow = () => {
        setPolicy(true);
        setShow(true);
    };
    
    useEffect(() => {
        const violation = document.getElementById("top-menu");
        window.scrollTo({
            top: violation.offsetTop,
            // behavior: "smooth",
        });
    }, []);

    return (
    <>
        <section id="gainDegreeview" className="gainAdegreeView">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-md-12 col-lg-12 text-center">
                        <h3 className="h1">
                            Gain a 360-degree view of your donor data and achieve automation at large.
                        </h3>
                        <p>Accelerate your mission delivery and work smarter with automation to drive donor engagement
                            in one place. Get Project Leadership, Change Management Consulting and User Training all for
                            a perpetual license. The Right Cause Solution comes pre-built with charity-specific features
                            such as constituent relationship management, grants management, member self-service, online
                            fundraising, social engagement, private communities- all in one seamless cloud-based system.
                        </p>
                    </div>
                </div>
                <div className="row mt-xl-5 accordion-wrapper">
                    <div className="col-md-6 col-lg-6">
                        <div className="imageConatiner">
                        </div>
                    </div>
                    <div className="col-md-12 col-lg-6">
                        <div className="acc-container">
                            <div className="accordion" id="accordionExample">
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingOne">
                                        <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseOne" aria-expanded="true"
                                            aria-controls="collapseOne">
                                            Constituent Relationship Management
                                        </button>
                                    </h2>
                                    <div id="collapseOne" className="accordion-collapse collapse show"
                                        aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                        <div className="accordion-body">
                                                <div className="imageConatiner">
                                                    <img className="accOne activechild" alt="constituent relationship management" src={benifits1} width="752" height="581" />
                                                </div>
                                            Nurture relationships with your existing and potential donors, clients,
                                            volunteers, and other stakeholders. Members, donors, and other constituents
                                            – as well as staff – can access the system from a web browser.
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingTwo">
                                        <button className="accordion-button collapsed" type="button"
                                            data-bs-toggle="collapse" data-bs-target="#collapseTwo"
                                            aria-expanded="false" aria-controls="collapseTwo">
                                            Fundraising CRM
                                        </button>
                                    </h2>
                                    <div id="collapseTwo" className="accordion-collapse collapse"
                                        aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                        <div className="accordion-body">
                                                <div className="imageConatiner">
                                                    <img className="accTwo" alt="Fundraising CRM" src={benifits2} width="752" height="581" />
                                                </div>
                                            Automate your fundraising efforts by aligning program needs with
                                            personalized supporter engagement. Collect data from a variety of donor
                                            signals, connect those behaviors with meaningful engagements, and
                                            provide suggestions for a next best action.
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingThree">
                                        <button className="accordion-button collapsed" type="button"
                                            data-bs-toggle="collapse" data-bs-target="#collapseThree"
                                            aria-expanded="false" aria-controls="collapseThree">
                                            Grant Management
                                        </button>
                                    </h2>
                                    <div id="collapseThree" className="accordion-collapse collapse"
                                        aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                        <div className="accordion-body">
                                                <div className="imageConatiner">
                                                    <img className="accThree" alt="Grant Management" src={benifits3} width="752" height="581" />
                                                </div>
                                            Engage with the Grantmakers through industry-leading donation features, grow
                                            your giving programs with recurring giving prompts, predict and seek for the
                                            perfect donation amount. The solution is perfectly designed to address
                                            average gift size and improve donor retention.
                                        </div>
                                    </div>
                                </div>


                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingFour">
                                        <button className="accordion-button collapsed" type="button"
                                            data-bs-toggle="collapse" data-bs-target="#collapseFour"
                                            aria-expanded="false" aria-controls="collapseFour">
                                            Volunteer Management
                                        </button>
                                    </h2>
                                    <div id="collapseFour" className="accordion-collapse collapse"
                                        aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                                        <div className="accordion-body">
                                                <div className="imageConatiner">
                                                    <img className="accFour" alt="Volunteer Management" src={benifits4} width="752" height="581" />
                                                </div>
                                            Manage their volunteer programs at scale and drive engagement by assigning
                                            tasks based on the program, volunteer interest, skillset, location, and
                                            other factors. Also, assign volunteers to a specific program or grant.
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingFive">
                                        <button className="accordion-button collapsed" type="button"
                                            data-bs-toggle="collapse" data-bs-target="#collapseFive"
                                            aria-expanded="false" aria-controls="collapseFive">
                                            Donor Cultivation
                                        </button>
                                    </h2>
                                    <div id="collapseFive" className="accordion-collapse collapse"
                                        aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                                        <div className="accordion-body">
                                                <div className="imageConatiner">
                                                    <img className="accFive" alt="Donor Cultivation" src={benifits5} width="752" height="581" />
                                                </div>
                                            Nurture one-to-one relationships with donors and seamlessly integrate
                                            business processes to set the stage for strategic direction and alignment of
                                            vision and your non-profit goals with a easy to use fundraising software for
                                            nonprofits.
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingSix">
                                        <button className="accordion-button collapsed" type="button"
                                            data-bs-toggle="collapse" data-bs-target="#collapsesix"
                                            aria-expanded="false" aria-controls="collapsesix">
                                            Reporting
                                        </button>
                                    </h2>
                                    <div id="collapsesix" className="accordion-collapse collapse"
                                        aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                                        <div className="accordion-body">
                                                <div className="imageConatiner">
                                                    <img className="accSix" alt="- Donor Reporting" src={benifits6} width="752" height="581" />
                                                </div>
                                            Gain mission-critical insights into your giving with pledge tracking,
                                            donations, grants, inactive donors, and other giving reports. Get
                                            custom-built Power BI dashboards for reporting capabilities.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section id="shceduleDemo_div1" className="shceduleDemo">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-lg-12">
              <div className="row align-items-center">
                <div className="col-md-6 col-lg-6">
                  <img
                    className="sad-f-image"
                    alt="nonprofit digital transformation"
                    width="494"
                    height="182"
                    src={democta1}
                  />
                  <img
                    className="sad-f-image-two"
                    alt="nonprofit digital transformation"
                    width="494"
                    height="182"
                    src={democta2}
                  />
                </div>
                <div className="col-md-6 col-lg-5">
                  <h2 className="h1 mt-xs-3">
                    Schedule a demo call with our team followed by an
                    interactive Q&amp;A session.
                  </h2>
                  <a
                    onClick={handleShow}
                    className="rc-primary-btn rc-large-btn rc-btn mt-xl-3"
                    tabIndex="0"
                    aria-label="Request Demo Button"
                  >
                    Request Demo <i className="icon-arrow"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Modal
        size="lg"
        show={show}
        onHide={handleClose}
        className="modal_getStartedForm"
      >
        <Modal.Header closeButton></Modal.Header>
        <Fcontact policy={policy} />
      </Modal>
    </>
    )
}

export default Benifits